import React from 'react';
import errorReporter from '@app/errorReporter';
import styled from 'styled-components';
import { ContactDrawerMode, ContactDrawerType } from '../../contexts';

const TeamName = styled.strong`
  white-space: normal;
  word-break: break-all;
`;

export interface TeamChatLinkProps {
  teamId?: string;
  teamName: string;
  openContactDrawer: (
    mode: ContactDrawerMode,
    type: ContactDrawerType,
    id?: string,
  ) => void;
}

const TeamChatLink: React.FC<TeamChatLinkProps> = ({
  teamId,
  teamName,
  openContactDrawer,
}) => {
  const chatLink = React.useRef<HTMLButtonElement>(null);

  const handleClick = React.useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();

      if (!openContactDrawer) {
        errorReporter.error(
          'Agent chat link was pressed but no callback was provided',
        );
      } else {
        openContactDrawer(
          ContactDrawerMode.Profile,
          ContactDrawerType.Team,
          teamId,
        );
      }
    },
    [teamId, openContactDrawer],
  );

  /* Changed from onClick to eventListener due to bubbling resulting 
  in the listing page opening instead of the Agent Drawer */
  React.useEffect(() => {
    const element = chatLink.current;

    if (element) {
      element.addEventListener('click', handleClick);
    }

    return () => {
      if (element) element.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  if (!teamId) {
    return <div>{teamName}</div>;
  }

  return (
    <button className="btn btn-link chat-link" ref={chatLink}>
      <TeamName>{teamName}</TeamName>
    </button>
  );
};

export default TeamChatLink;
